import { render } from "./ViewsSurveySubmitted.vue?vue&type=template&id=687c61c6"
import script from "./ViewsSurveySubmitted.vue?vue&type=script&lang=js"
export * from "./ViewsSurveySubmitted.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__